/* @flow */

import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';

export default Tooltip;
